
if ($('.info-boxes--box').length > 0) {

	$('.info-boxes--box--expand').on('click', function(e) {

		e.preventDefault();

		var _this = $(this);
		var curBox = _this.parent();
		$('.info-boxes--box').removeClass('is-expanded');
		curBox.addClass('is-expanded');

	});

}
